import React from 'react';

import { Row, Col } from 'antd';
import { Slot } from 'common/components';

const SecurityItemWrapperContent = ({ children }) => {
  return (
    <Row align='middle'>
      <Col flex='400px'>
        <Slot name='label'>{children}</Slot>
      </Col>
      <Col flex='1' />
      <Col flex='250px'>
        <Slot name='status'>{children}</Slot>
      </Col>
      <Col flex='1' />
      <Col flex='200px' className='user-security-tab__item-control'>
        <Slot name='control'>{children}</Slot>
      </Col>
    </Row>
  );
};

export default SecurityItemWrapperContent;
